import auth from "@evercam/shared/plugins/auth"
import { useAccountStore } from "@evercam/admin/stores/account"
import { defineNuxtPlugin } from "#app"

const authPlugin = auth(useAccountStore)

export default defineNuxtPlugin(authPlugin)
